import { useEffect, useState } from "react";
import { useMercuryContext } from "../../context/index";
import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";
import { Loader } from "../../shared/components/Components";
import { performAuth0Login } from "../authHelpers";
import { ROUTES } from "../../common/constants/routes";
import { AxiosError } from "axios";

const LoginPage = () => {
    const context = useMercuryContext();
    const auth0 = useAuth0();
    const [loading, setLoading] = useState(true);
    const [redirectTo, setRedirectTo] = useState<string | undefined>(undefined);

    // use cookie instead of context to prevent flicker
    const cookieToken = Cookies.get("mercury_shared_token");
    const isTokenValid = context?.verifyToken?.(cookieToken || "");

    // handle valid MAS token immediately
    if (isTokenValid) {
        if (!context?.accessToken && cookieToken) {
            context.setToken(cookieToken);
        }
        return null;
    }
    
    useEffect(() => {
        // Wait for Auth0 to initialise
        if (auth0.isLoading) return;

        if (Cookies.get("logged_out") === "true") {
            setLoading(false);
            return;
        }

        // Auth0 session exists
        if (auth0.isAuthenticated) {
            performLogin();
            return;
        }

        // No session, go to Auth0
        context?.removeToken?.();

        auth0.loginWithRedirect({
            appState: {
                returnTo: window.location.pathname,
            },
        });
    }, [auth0.isLoading, auth0.isAuthenticated]);

    useEffect(() => {
        if (redirectTo && context?.navigate) {
            context.navigate(redirectTo, {
                replace: true,
                state: {
                    autoRedirect: true,
                    delay: 5,
                    reason: "TOKEN_AUTH_FAILED",
                },
            });
        }
    }, [redirectTo, context]);

    const performLogin = async () => {
        try {
            setLoading(true);

            const masToken = await performAuth0Login(auth0, context);

            // set MAS token
            context.setToken(masToken);

        } catch (error: any) {
            console.error("Login error:", error);

            if (error?.code === "TOKEN_AUTH_FAILED") {
                setLoading(false);
                setRedirectTo(ROUTES.UNAUTHENTICATED);
                return;
            }

            const status = (error as AxiosError).response?.status;
            const redirectPath =
                status === 401 || status === 403
                    ? ROUTES.UNAUTHENTICATED
                    : ROUTES.AUTHERROR;

            setLoading(false);
            setRedirectTo(redirectPath);
        }
    };

    if (loading) {
        return <Loader animate={true} logo={true} title={"Authenticating..."} />;
    }

   return null;
};

export default LoginPage;
